import { PaginationInfo } from '../shared';
import { graphqlApiWithPersisted } from './graphqlApi';

export interface PlaceItem {
  displayName: string;
  formattedAddress: string;
}

interface LocationPlacesSearchPayload {
  items: PlaceItem[];
  pageInfo: PaginationInfo;
}

interface LocationPlacesSearchArgs {
  searchText: string;
  page?: number;
  size?: number;
}

interface LocationPlacesSearchResponse {
  data: {
    locationPlacesSearch: {
      payload: LocationPlacesSearchPayload;
    };
  };
}

export const locationApi = graphqlApiWithPersisted.injectEndpoints({
  endpoints: (builder) => ({
    locationPlacesSearch: builder.query<LocationPlacesSearchPayload, LocationPlacesSearchArgs>({
      query: ({ searchText, page = 1, size = 10 }) => ({
        url: '/graphql/webapp?locationPlacesSearch',
        method: 'POST',
        body: {
          query: `query LocationPlacesSearch($searchText: String!, $page: Int, $size: Int) {
            locationPlacesSearch(searchText: $searchText, page: $page, size: $size) {
              payload {
                items {
                  displayName
                  formattedAddress
                }
                pageInfo {
                  page
                  hasNextPage
                }
              }
            }
          }`,
          variables: { searchText, page, size },
        },
      }),
      transformResponse: (response: LocationPlacesSearchResponse) =>
        response.data.locationPlacesSearch.payload,
    }),
  }),
});

export const { useLocationPlacesSearchQuery } = locationApi;
